import {Routes} from '@angular/router';
import {ProjectManagementComponent} from './dashboard/project-management/project-management.component';
import {NotFoundComponent} from './common/not-found/not-found.component';
import {AuthenticationComponent} from './authentication/authentication.component';
import {SignInComponent} from './authentication/sign-in/sign-in.component';
import {SignUpComponent} from './authentication/sign-up/sign-up.component';
import {ForgotPasswordComponent} from './authentication/forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './authentication/reset-password/reset-password.component';
import {LockScreenComponent} from './authentication/lock-screen/lock-screen.component';
import {LogoutComponent} from './authentication/logout/logout.component';
import {ConfirmEmailComponent} from './authentication/confirm-email/confirm-email.component';
import {SettingsComponent} from './settings/settings.component';
import {AccountSettingsComponent} from './settings/account-settings/account-settings.component';
import {ChangePasswordComponent} from './settings/change-password/change-password.component';
import {LaboComponent} from './settings/labo/labo.component';
import {PrivacyPolicyComponent} from './settings/privacy-policy/privacy-policy.component';
import {TermsConditionsComponent} from './settings/terms-conditions/terms-conditions.component';
import {authGuard} from "./customs/_guards/auth.guard";
import {MyProfileComponent} from "./my-profile/my-profile.component";
import {ReportComponent} from "./customs/_components/report/report.component";
import {SamplesComponent} from "./customs/_components/samples/samples.component";

import {
    ClientsPocDetailsComponent
} from "./customs/_components/manage-clients-poc/clients-poc-details/clients-poc-details.component";
import {
    ClientsExploitationDetailsComponent
} from "./customs/_components/manage-clients-exploitation/clients-exploitation-details/clients-exploitation-details.component";
import {
    ClientsTerrainDetailsComponent
} from "./customs/_components/manage-clients-terrain/clients-terrain-details/clients-terrain-details.component";
import {
    ClientsSampleDetailsComponent
} from "./customs/_components/manage-samplers/clients-sample-details/clients-sample-details.component";
import {SamplerListComponent} from "./customs/_components/manage-samplers/sampler-list/sampler-list.component";
import {
    ClientsTerrainListComponent
} from "./customs/_components/manage-clients-terrain/clients-terrain-list/clients-terrain-list.component";
import {ClientListComponent} from "./customs/_components/manage-clients/client-list/client-list.component";
import {
    ClientsExploitationListComponent
} from "./customs/_components/manage-clients-exploitation/clients-exploitation-list/clients-exploitation-list.component";
import {ResultListComponent} from "./customs/_components/result/result-list/result-list.component";
import {
    ClientPOCListComponent
} from "./customs/_components/manage-clients-poc/clients-poc-list/clients-poc-list.component";
import {NavbarClientsDetailsComponent} from "./common/navbar-clients-details/navbar-clients-details.component";
import {
    InProgressAnalysesComponent
} from "./customs/_components/analyse/in-progress-analyses/in-progress-analyses.component";
import {CalculatedAnalyse} from "./customs/_components/analyse/calculated-analyses/calculated-analyses.component";
import {ValidatedAnalyse} from "./customs/_components/analyse/validated-analyses/validated-analyses.component";
import { ManageUsersComponent } from './customs/_components/manage-users/manage-users.component';
import { ManageMatriceComponent } from './customs/_components/manage-matrice/manage-matrice.component';
import { ManageParameterComponent } from './customs/_components/manage-parameter/manage-parameter.component';
import { TypeAnalyseComponent } from './customs/_components/type-analyse/type-analyse.component';
import { ChatComponent } from './customs/_components/chat/chat.component';
import { LaboListComponent } from './customs/_components/manage-labo/labo-list/labo-list.component';
import { AccreditationComponent } from './customs/_components/manage-acc/acc-list/acc-list.component';
import { ActiveSubstanceComponent } from './customs/_components/activeSubstance/activeSubstance.component';
import { DevisComponent } from './customs/_components/Devis/devis.component';
import { LotDetailsComponent } from './customs/_components/Lot/lot-details/lot-details.component';
import { LotComponent } from './customs/_components/Lot/lot.component';
import { NotificationsComponent } from './customs/_components/notifications/notifications.component'
import { BonsCommandeComponent } from './customs/_components/Bons_Commande/bonsCommande.component';
import { Sign } from 'node:crypto';
import { SignatureComponent } from './signature/signature.component';
import { FournisseurComponent } from './customs/_components/Stock/fournisseur/fournisseur.component';
import { EmplacementComponent } from './customs/_components/Stock/emplacement/emplacement.component';
import { StockProduitComponent } from './customs/_components/Stock/stock-produit/stock-produit.component';
import { MouvementComponent } from './customs/_components/Stock/mouvement/mouvement.component';
import { BenchSheetComponent } from './customs/_components/bench-sheet/bench-sheet.component';
import { ReportDetailComponent } from './customs/_components/report/reportDetail/reportDetail.component';
import { PrelevementComponent } from './customs/_components/Sample/Prelevement/prelevement/prelevement.component';
import { ReceptionComponent } from './customs/_components/Sample/Reception/reception.component';
import { FichePaillasseComponent } from './customs/_components/fiche-paillasse/fiche-paillasse.component';
import { MethodStepComponent } from './customs/_components/method-step/method-step.component';
import { MethodeComponent } from './customs/_components/methode/methode.component';
export const routes: Routes = [

    {path: 'project-management', component: ProjectManagementComponent},

    {
        path: 'authentication',
        component: AuthenticationComponent,
        children: [
            {path: '', component: SignInComponent},
            {path: 'sign-up', component: SignUpComponent},
            {path: 'forgot-password', component: ForgotPasswordComponent},
            {path: 'reset-password', component: ResetPasswordComponent},
            {path: 'lock-screen', component: LockScreenComponent},
            {path: 'confirm-email', component: ConfirmEmailComponent},
            {path: 'logout', component: LogoutComponent}

        ]
    },
    {path: 'my-profile', component: MyProfileComponent},
    {
        path: 'settings',
        component: SettingsComponent,
        children: [
            {path: '', component: AccountSettingsComponent},
            {path: 'change-password', component: ChangePasswordComponent},
            {path: 'labo', component: LaboComponent},
            {path: 'privacy-policy', component: PrivacyPolicyComponent},
            {path: 'terms-conditions', component: TermsConditionsComponent}
        ]
    },
    // Custom Routes
    {
        path: '',
        component: ProjectManagementComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-clients',
        component: ClientListComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-prelevemnt',
        component: PrelevementComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-reception',
        component: ReceptionComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-users',
        component: ManageUsersComponent,
        canActivate: [authGuard]
    },
    {
        path: 'calendar',
        component: BenchSheetComponent,
        canActivate: [authGuard]
    },
    {
        path: 'In-Progress-Analyses-Component',
        component: InProgressAnalysesComponent,
        canActivate: [authGuard]
    },
    {
        path: 'calculated-analyses-compo',
        component: CalculatedAnalyse,
        canActivate: [authGuard]
    },
    {
        path: 'validated-analyses-compo',
        component: ValidatedAnalyse,
        canActivate: [authGuard]
    },
    {
        path: 'client-details/:id',
        component: NavbarClientsDetailsComponent,
        canActivate: [authGuard]
    },
    {
        path: 'fiche-paillasse',
        component: FichePaillasseComponent,
        canActivate: [authGuard]
    },
        {
        path: 'methode',
        component: MethodeComponent,
        canActivate: [authGuard]
    },
    {
        path: 'methode-step',
        component: MethodStepComponent,
        canActivate: [authGuard]
    },
    {
        path: 'sample-details/:id',
        component: LotDetailsComponent,
        canActivate: [authGuard]
    },
    {
        path: 'rapport-details/:id',
        component: ReportDetailComponent,
        canActivate: [authGuard]
    },
    {
        path: 'clients-poc-details/:id',
        component: ClientsPocDetailsComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-clients-poc',
        component: ClientPOCListComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-clients-exploitation',
        component: ClientsExploitationListComponent,
        canActivate: [authGuard]
    },
    {
        path: 'chat',
        component: ChatComponent,
        canActivate: [authGuard]
    },
    {
        path: 'clients-exploitation-details/:id',
        component: ClientsExploitationDetailsComponent,
        canActivate: [authGuard]
    },
    {
        path: 'propals',
        component: DevisComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-terrain',
        component: ClientsTerrainListComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-samplers',
        component: SamplerListComponent,
        canActivate: [authGuard]
    },
    {
        path: 'clients-terrain-details/:id',
        component: ClientsTerrainDetailsComponent,
        canActivate: [authGuard]
    },

    {
        path: 'manage-results',
        component: ResultListComponent,
        canActivate: [authGuard]
    },
    {
        path: 'report',
        component: ReportComponent,
        canActivate: [authGuard]
    },
    {
        path: 'notifications',
        component: NotificationsComponent,
        canActivate: [authGuard]

    },
    {
        path: 'samples',
        component: SamplesComponent,
        canActivate: [authGuard]
    },
    {
        path: 'lots',
        component: LotComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-fournisseur',
        component: FournisseurComponent,
        canActivate: [authGuard]
    },
        {
        path: 'manage-mouvement',
        component: MouvementComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-produit',
        component: StockProduitComponent,
        canActivate: [authGuard]
    },
        {
        path: 'manage-emplacement',
        component: EmplacementComponent,
        canActivate: [authGuard]
    },
    {
        path: 'clients-sample-details/:id',
        component: ClientsSampleDetailsComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-matrice',
        component: ManageMatriceComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-parameter',
        component: ManageParameterComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-type-analyse',
        component: TypeAnalyseComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-labo',
        component: LaboListComponent,
        canActivate: [authGuard]
    },
    {
        path: 'bdc',
        component: BonsCommandeComponent,
        canActivate: [authGuard]
    },
        {
        path: 'signature',
        component: SignatureComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-acc',
        component: AccreditationComponent,
        canActivate: [authGuard]
    },
    {
        path: 'manage-actSub',
        component: ActiveSubstanceComponent,
        canActivate: [authGuard]
    },
    {path: '**', component: NotFoundComponent} // This line will remain down from the whole pages component list
];
